import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-trending-down",
  templateUrl: "./med-icon-trending-down.component.html",
})
export class MedIconTrendingDownComponent extends SvgMixinComponent {}
